import { useState, useEffect } from 'react';
import api from './api';
import { useAuth } from './AuthContext';

export function Contacts() {
    const [contacts, setContacts] = useState([]);
    const [name, setName] = useState('');
    const [relevance, setRelevance] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const { user } = useAuth();
    const isAdmin = user?.role === 'admin';

    const load = () => {
        api.get('/contacts').then((res) => setContacts(res.data));
    };

    useEffect(() => { load(); }, []);

    const addContact = async (e) => {
        e.preventDefault();
        if (!name) return;
        await api.post('/contacts', { name, relevance, phone, email });
        setName(''); setRelevance(''); setPhone(''); setEmail('');
        load();
    };

    const deleteContact = async (id) => {
        await api.delete(`/contacts/${id}`);
        load();
    };

    return (
        <div className="contacts-page">
            <h2>Contacts</h2>

            {isAdmin && (
                <form onSubmit={addContact} className="add-contact-form">
                    <input placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
                    <input placeholder="Relevance" value={relevance} onChange={(e) => setRelevance(e.target.value)} />
                    <input placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
                    <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    <button type="submit">Add Contact</button>
                </form>
            )}

            <div className="contacts-list">
                {contacts.map((c) => (
                    <div key={c.id} className="contact-item">
                        <strong>{c.name}</strong> — {c.relevance}
                        <div>{c.phone} {c.email}</div>
                        {isAdmin && <button onClick={() => deleteContact(c.id)}>Delete</button>}
                    </div>
                ))}
            </div>
        </div>
    );
}
